import React, { Component } from "react";

export default class EmploymentDetailItemTextBox extends Component {
  render() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 15,
        }}
      >
        <div>{this.props.label}</div>
        <div
          className="col-lg-7 col-md-5"
          style={{
            border: "1px solid #d9d9d9",
            padding: "10px 12px 10px 12px",
            height: !!this.props.value ? null : 40,
          }}
        >
          <div
            style={{
              fontSize: 14,
            }}
          >
            {this.props.value}
          </div>
        </div>
      </div>
    );
  }
}
